import { NgModule } from '@angular/core';

import { sentryClientMonitoring } from '../sentry/sentry-client-monitoring';
import { MonitoringModule } from './monitoring.interface';
import { MONITORING } from './monitoring.token';
import { MonitoringAdapter } from './monitoring-adapter';
import { MonitoringLogger } from './monitoring-logger';
import { DatadogMonitoring, DatadogSessionMode } from './datadog-client-monitoring';
import { clientConsoleMonitoring } from './console-client-monitoring';
import { handleChunkLoadError } from './chunk-load';

const datadogMonitoring = new DatadogMonitoring();

/** The client monitoring adapter, composing the console, Sentry and Datadog backends. */
export const clientMonitoring: MonitoringModule = new MonitoringAdapter(
  [clientConsoleMonitoring, sentryClientMonitoring, datadogMonitoring],
  handleChunkLoadError
);

export const initClientMonitoring = (): void => clientMonitoring.init();

/**
 * Initialises the Datadog RUM/Logs backend with the given persistence mode. Called by the consent
 * orchestrator (not at bootstrap) so the SDK — and its session cookie — only start once consent is
 * known. See {@link DatadogMonitoring.start}.
 */
export const startDatadogClientMonitoring = (mode: DatadogSessionMode): void => datadogMonitoring.start(mode);

@NgModule({
  providers: [{ provide: MONITORING, useValue: clientMonitoring }, MonitoringLogger],
})
export class MonitoringAdapterModule {}
